import { Api } from '@/core/api.js'
const api = new Api()

// initial state
const state = {
  list: []
}

// getters
const getters = {

  getList: (state, getters, rootState) => (type) => {
    return state.list
  },

  get_by_id: (state, getters, rootState) => (id) => {
    if (typeof state.list[ id ] !== 'undefined') return state.list[ id ]
    return false
  }

}

// actions
const actions = {

  loadList ({ commit }, params) {
    var path = 'miclive/facility'
    return api.get(path).then(function (response) {
      if (response.status) {
        var data = response.data
        return commit('setList', data)
      }
    })
  }
}

// mutations
const mutations = {

  setList (state, data) {
    state.list = data
  }

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
